var map = {
	"./zoohit.cz/private-rws.jpg": 2619,
	"./zoohit.cz/public-rws.jpg": 6769,
	"./zooplus.co.uk/private-rws.jpg": 1341,
	"./zooplus.co.uk/public-rws.jpg": 8215,
	"./zooplus.pl/private-rws.jpg": 2427,
	"./zooplus.pl/public-rws.jpg": 593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5532;